import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { baseUrlFunc } from '../../app/app.module';
import { HttpInterceptorProvider, Filter } from '../http-interceptor/http-interceptor';

/*
  Generated class for the DocumentosProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AtlasPatologiaProvider {

    apiBase = baseUrlFunc() + "wp/v2/atlaspatologia?per_page=100"

  memoryCache

  constructor(public http: HttpInterceptorProvider) {
    console.log('Hello DocumentosProvider Provider');
  }

  solicitarAtlasPatologia(filter?: Array<Filter>): Observable<any> {
    return Observable.create(observer => {

      if (this.memoryCache != undefined)
        observer.next(this.memoryCache)

      this.http.getFiltered(this.apiBase, filter).subscribe(data => {
        this.memoryCache = data
        observer.next(data)
        console.log("register success response", data)
      }, err => {
        observer.error("Não foi possivel solicitar os Atlas de Patologias")
        console.log("register error response", err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/atlas-patologia/atlas-patologia.ts